import { useQueries } from "@tanstack/react-query";

import sourcingService from "@services/sourcing.service";
import { IThemeOption } from "@interfaces/sourcing.interface";
import { QUERY_CACHE_EXTRA_LONG_EXPIRATION_MS, SOURCING_THEMES_TREE_QUERY_KEY } from "@config/query";

const THEME_TREE_FIELDS = "{id,title,parent_id,level,parent_list}";

export function useGetThemeTree(sourcingThemes?: IThemeOption[]) {
  const parentIds = sourcingThemes?.map((i) => i.id) ?? [];

  return useQueries({
    queries:
      parentIds?.length > 0
        ? parentIds?.map((parentId) => {
          return {
            queryKey: [SOURCING_THEMES_TREE_QUERY_KEY, parentId],
            queryFn: async () =>
              await sourcingService.getSourcingThemesTree(parentId, THEME_TREE_FIELDS),
            staleTime: QUERY_CACHE_EXTRA_LONG_EXPIRATION_MS,
          };
        })
        : [],
  });
}
